/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Avatar } from "@material-ui/core";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const { adviser } = props;

  return (
    <tr key={adviser.AdviserID}>
      <td className="text-left">
        <div className="d-flex align-items-center">
          <Avatar alt="Avatar" src={adviser.AdviserPhotoURL} className="mr-2" />
          <div>
            <a
              onClick={(e) => e.preventDefault()}
              className="font-weight-bold text-black"
              title={adviser.AdviserName}
            >
              {adviser.AdviserName} {adviser.AdviserLastname}
            </a>
          </div>
        </div>
      </td>
      <td className="text-left">{adviser.AdviserNumber}</td>
      <td className="text-left">{adviser.AdviserMail}</td>
    </tr>
  );
};
